import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import { Slider } from '@mantine/core'

import { Z_INDEX } from 'interfaces/constants'

// this is the full size container
export const StyledWeekOfPregnancyContainer = styled.div`
  position: relative;
  width: 100%;
  overflow-x: hidden;
  background-color: ${theme?.colors.pink50};
  ${MediaQueries.mbDown} {
    & > div {
      padding: 0 0;
    }
  }
`

// content container with padding
export const StyledContentContainer = styled.div`
  position: relative;
  padding: 40px;

  ${MediaQueries.mbDown} {
    padding: 0;
  }
`

export const StyledPillContainer = styled.div`
  display: inline-block;
  height: 108px;
  background-color: ${theme.colors.white};
  border-radius: 60px;
  cursor: pointer;
  &.selected-week-pill {
    background-color: ${theme.colors.pink100};
  }

  & > div:first-of-type {
    margin: 4px 4px 0;
  }

  & > p {
    margin-top: 8px;
    text-align: center;
  }
`

export const StyledWeekOfPregnancy = styled.div`
  & .title {
    text-align: center;
    &[data-space-bottom='true'] {
      padding-bottom: 168px;
    }
  }
`

export const StyledScrollContainer = styled.div`
  position: relative;
  height: 120px;
  margin-top: 16px;

  & > .slick-slider {
    position: absolute;
    top: 0;
    left: 50%;
    width: 1032px;
    margin: auto;

    transform: translateX(-50%);
  }

  & .centered-pill-wrapper {
    text-align: center;
  }

  & .week-pill {
    transition: all 0.4s;

    &:not(.selected-week-pill) {
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.08);
    }

    &.opacity-50 {
      opacity: 0.5;
    }

    &.opacity-10 {
      opacity: 0.1;
    }

    &.opacity-0 {
      opacity: 0;
    }
  }

  &[data-is-sticky='true'] {
    position: fixed;
    z-index: ${Z_INDEX.menuSearchPopup - 1};
    top: 68px;
    left: 0;
    width: 100vw;
    margin-top: 0;
    background-color: ${theme.colors.primaryBase};
    transition: all 0.2s linear;

    ${MediaQueries.mbDown} {
      top: 48px;
    }

    &[data-visible='false'] {
      top: -98px;
      ${MediaQueries.mbDown} {
        top: -170px;
      }
    }

    &[data-hideontop='true'] {
      ${MediaQueries.mbDown} {
        top: -168px;
      }
    }

    > div {
      height: 168px;
      margin-top: 0;
    }

    .centered-pill-wrapper {
      padding: 24px 0;
    }
  }
`

export const StyledWeekDetailArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  margin-top: 32px;
  .infant-image {
    flex-shrink: 0;
    min-width: 0;
    min-height: 0;
    aspect-ratio: 1;
    border: 4px solid #ffffff;
    border-radius: 50%;
    object-fit: contain;
    padding: 24px;
    img {
      width: 200px;
      height: 200px;
      aspect-ratio: 1;
    }
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  ${MediaQueries.mbDown} {
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 16px 16px 0px 0px;
    padding: 32px;
    border-bottom: 8px solid ${theme?.colors.neutral50};
    .detail {
      align-items: center;
      text-align: center;
    }
    .infant-image {
      display: none;
    }
  }
`

export const StyledStickyTopbar = styled.div`
  position: fixed;
  z-index: ${Z_INDEX.menuSearchPopup + 1};
  top: 0;
  left: 0;
  width: 100vw;
  background-color: ${theme.colors.white};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.2s linear;

  &:after {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    width: calc(var(--reading-progress) * 100%);
    height: 2px;
    background-color: #e85388;
    content: '';
    transition: width 0.2s ease;
  }

  ${MediaQueries.mbDown} {
    background-color: #e85388;
    &:after {
      display: none;
    }
  }

  &[data-visible='false'] {
    top: -70px;
  }

  .container {
    display: flex;
    align-items: center;
    padding: 21px 0;
  }

  .mobile-container {
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }

  .mb-logo {
    width: auto;
    height: 28px;
    margin-right: 24px;
    cursor: pointer;
  }

  .clickable-area {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .text {
    padding: 0 12px 0 24px;
    border-left: 1px solid ${theme.colors.gray600};
    font-weight: 600;
  }

  .arrow {
    width: 8px;
    transition: all 0.2s ease;

    &[data-reverse='true'] {
      transform: rotateZ(-180deg);
    }
  }

  .fruit-icon {
    margin-right: 16px;
  }

  .mobile-text {
    font-weight: 600;
  }

  .mobile-arrow {
    margin-left: auto;
    transform: rotateZ(90deg);
    transition: all 0.2s ease;

    &[data-reverse='true'] {
      transform: rotateZ(-90deg);
    }
  }
`
type IconProps = {
  iconSrc: string
  color?: string
  size?: number
}

export const StyledIcon = styled.span<IconProps>`
  display: inline-block;
  overflow: hidden;

  width: ${(props: IconProps) => props.size}px;
  height: ${(props: IconProps) => props.size}px;

  background-color: ${(props: IconProps) => props.color};
  background-repeat: no-repeat;

  -webkit-mask-image: url(${(props: IconProps) => props.iconSrc});
  mask-image: url(${(props: IconProps) => props.iconSrc});
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
`

type IconContainerProps = {
  iconSize?: number
  size?: number
  backgroundColor?: string
  borderRadius?: string
}

export const StyledIconContainer = styled.div<IconContainerProps>`
  display: inline-flex;
  overflow: hidden;
  width: ${(props: IconContainerProps) => props.size}px;
  height: ${(props: IconContainerProps) => props.size}px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;

  border: 1px solid #e4e8ec;
  background-color: ${(props: IconContainerProps) =>
    props.backgroundColor || theme?.colors.white};
  border-radius: ${(props: IconContainerProps) => props.borderRadius || '50%'};
  & > * {
    width: ${(props: IconContainerProps) => props.iconSize}px;
    height: ${(props: IconContainerProps) => props.iconSize}px;
  }
`

export const StyledArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  z-index: 1;
  &.slick-arrow::before {
    display: none;
  }
`

export const StyledTrimester = styled.div`
  width: 100%;
  background-color: ${theme?.colors.pink50};
  position: relative;

  .mantine-Popover-dropdown {
    padding: 8px;
    background: ${theme?.colors.neutral50};
    border-radius: 4px;
    text-align: center;
    pointer-events: all;
  }
`

export const StyledSlider = styled(Slider)`
  transform: translateY(-4px);
  z-index: 0;
  pointer-events: none;
  user-select: none;
  .mantine-Slider-bar {
    background-color: ${theme?.colors.pink600};
    border-radius: 0;
  }
  .mantine-Slider-track {
    background-color: ${theme?.colors.neutral200};
    height: 12px;
    border-radius: 0;
    &::before {
      border-radius: 0;
    }
  }
  .mantine-Slider-thumb {
    background-color: ${theme?.colors.pink600};
    border: 2px solid #ffffff;
  }
  .mantine-Slider-markFilled {
    border-color: ${theme?.colors.pink600};
  }
`
